'use client';
import styles from './styles.module.css';
import { useState } from 'react';
import InTouchModal from './InTouchModal';
import { useToast } from '../../../hooks/useToast/useToast';
import { API_BASE_LINK, INTERNAL_LINKS } from '@/constants/links';
import axios from 'axios';

export default function InTouchSection() {
  const [formData, setFormData] = useState({
    name: '',
    telegram: ''
  });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    name: false,
    telegram: false,
    consent: false
  });
  const { addToast } = useToast();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'name') {
      setFieldErrors(prev => ({ ...prev, name: false }));
    }
    if (name === 'telegram') {
      setFieldErrors(prev => ({ ...prev, telegram: false }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const nameInvalid = !formData.name.trim();
    const telegramInvalid = !formData.telegram.trim();
    const consentInvalid = !isAgreed;

    setFieldErrors({
      name: nameInvalid,
      telegram: telegramInvalid,
      consent: consentInvalid
    });

    if (nameInvalid) {
      addToast('Забыли ввести имя', 'error');
      return;
    }

    if (telegramInvalid) {
      addToast('Забыли ввести телеграм', 'error');
      return;
    }

    if (consentInvalid) {
      addToast(
        'Необходимо согласиться с политикой конфиденциальности, офертой и пользовательским соглашением',
        'error'
      );
      return;
    }

    setIsSubmitting(true);

    try {
      await axios.post(`${API_BASE_LINK}/applications/create`, {
        name: formData.name.trim(),
        telegram: formData.telegram.trim()
      });

      setFieldErrors({ name: false, telegram: false, consent: false });
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error submitting form:', error);
      addToast('Ошибка отправки. Попробуйте ещё раз', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({ name: '', telegram: '' });
    setIsAgreed(false);
    setFieldErrors({ name: false, telegram: false, consent: false });
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsAgreed(checked);
    if (checked) {
      setFieldErrors(prev => ({ ...prev, consent: false }));
    }
  };

  return (
    <>
      <section id="contacts" className={styles.inTouchSection}>
        <div className={styles.leftBlock}>
          <h2 className={styles.title}>На связи 24/7</h2>
        </div>

        <div className={styles.rightBlock}>
          <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div className={styles.inputGroup}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Имя"
                className={`${styles.input} ${fieldErrors.name ? styles.inputError : ''}`}
                aria-invalid={fieldErrors.name}
                disabled={isSubmitting}
              />
            </div>

            <div className={styles.inputGroup}>
              <input
                type="text"
                name="telegram"
                value={formData.telegram}
                onChange={handleInputChange}
                placeholder="Ваш телеграм"
                className={`${styles.input} ${fieldErrors.telegram ? styles.inputError : ''}`}
                aria-invalid={fieldErrors.telegram}
                disabled={isSubmitting}
              />
            </div>

            <div
              className={`${styles.checkboxGroup} ${fieldErrors.consent ? styles.checkboxGroupError : ''}`}
            >
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={isAgreed}
                  onChange={handleCheckboxChange}
                  disabled={isSubmitting}
                  className={styles.checkbox}
                />
                <span className={styles.checkboxText}>
                  Я согласен с{' '}
                  <a href={INTERNAL_LINKS.PRIVACY} className={styles.link}>
                    политикой конфиденциальности
                  </a>
                  ,{' '}
                  <a href={INTERNAL_LINKS.OFFER} className={styles.link}>
                    публичной офертой
                  </a>{' '}
                  и{' '}
                  <a href={INTERNAL_LINKS.TERMS} className={styles.link}>
                    пользовательским соглашением
                  </a>{' '}
                  и даю согласие на обработку персональных данных в соответствии с{' '}
                  <a href={INTERNAL_LINKS.CONSENT} className={styles.link}>
                    формой согласия
                  </a>
                  .
                </span>
              </label>
            </div>

            <button
              type="submit"
              className={styles.submitButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Отправка...' : 'Отправить'}
            </button>
          </form>
        </div>
      </section>

      <InTouchModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
} 